
import { ApiTags, rootApi } from "../../../../services/rootApi"
import { IExamSchedule } from "./examSchedule"

const TAG = ApiTags.ExamSchedule;
const getTags = (entities: IExamSchedule[]) => [...entities.map((p) => ({ type: TAG, id: p.id })), TAG]

const examScheduleApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getExamSchedules: builder.query<IExamSchedule[], string>({
      query: (contactId) => `/Schedule/${contactId}`,
      providesTags: (result) => result ? getTags(result) : [TAG]
    }),
  })
})

export const {
  useGetExamSchedulesQuery, 
  useLazyGetExamSchedulesQuery 
} = examScheduleApi;